import { useNextgenRouter } from '@nextgen-web-framework/all';
import { LogoutPath } from '@commerce-identity-webcomponents/sdk';
const useLogOut = () => {
  const configs = ConfigService.getConfigs();
  const { replace } = useNextgenRouter();
  const baseUrl = ApiConfigService.getBaseUrl();
  const getSignOutUrl = () => {
    const postAuthUrl = btoa(
      JSON.stringify({
        redirectUri: `${configs.NEXT_PUBLIC_WEB_BASE_PATH}/logout`,
      }),
    );
    const postLogoutRedirectUri = `${baseUrl}/comgluuoidc/v1/logout?state=${postAuthUrl}`;
    const logoutUrl = `${configs.NEXT_PUBLIC_GLU_BASE_URL}/${LogoutPath}?post_logout_redirect_uri=${postLogoutRedirectUri}`;
    replace?.(logoutUrl);
  };
  return { getSignOutUrl };
};
export default useLogOut;
